import { hasPermission, PERM } from '../accessPermissions';

export const canManageAllTenantApprovals = (userInfo) => hasPermission(userInfo, PERM.APPROVAL_QUERY_TENANT_ALL);

export const canWithdrawApproval = (approval, userInfo) => {
	if (!approval || approval.status !== 'waitingApproval' || !userInfo) return false;
	if (canManageAllTenantApprovals(userInfo)) return true;
	const uid = String(userInfo._id || '');
	if (!uid) return false;
	const isApplicant = String(approval.applicant?._id || approval.applicant || '') === uid;
	const isAssistant = String(approval.assistant?._id || approval.assistant || '') === uid;
	return isApplicant || isAssistant;
};

export const canWithdrawApplyingOrder = (order, userInfo) => {
	if (!order || order.approvalStatus !== 'inProcessOfApproval' || !userInfo) return false;
	if (canManageAllTenantApprovals(userInfo)) return true;
	const uid = String(userInfo._id || '');
	if (!uid) return false;
	return [order.createdUser, order.saleUser, order.assistantUser].some((person) => String(person?._id || person || '') === uid);
};
